import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [],
  imports: [CommonModule],
})
export class AdminUserModule {
  adminID: number;
  adminName: string;
  adminLastName: string;
  adminEmail: string;
  adminImgProfile: string;
  adminType: number;
  adminStatus: number;
  adminImgProfileFile?: File;
  adminPassword?: string;
  adminCreated: Date;
}
